// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.timer-additional-container {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 12px 0;
  min-width: 100%;
  background-color: var(--orange);
}

.timer-additional-container.almost-finished {
  background-color: var(--red);
  color: var(--white);
}

.timer-additional-container .timer-description {
  margin-left: 8px;
  color: var(--white);
  font-size: 14px;
  font-weight: 600;
  line-height: 17px;
}

.timer-additional-container .timer-description.almost-finished {
  color: white;
}

.timer-additional-container .time {
  margin: 0 5px;
  color: var(--black);
  font-size: 16px;
  font-weight: 600;
  line-height: 120%;
}

.timer-additional-container .interval {
  color: var(--white);
  font-size: 14px;
  font-weight: 600;
  line-height: 17px;
}


.timer-additional-container .time.almost-finished {
  color: var(--white);
}`, "",{"version":3,"sources":["webpack://./src/orgfit/pilates-3-ltp/css/components/components.timer-container.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;;AAGA;EACE,mBAAmB;AACrB","sourcesContent":[".timer-additional-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 12px 0;\n  min-width: 100%;\n  background-color: var(--orange);\n}\n\n.timer-additional-container.almost-finished {\n  background-color: var(--red);\n  color: var(--white);\n}\n\n.timer-additional-container .timer-description {\n  margin-left: 8px;\n  color: var(--white);\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 17px;\n}\n\n.timer-additional-container .timer-description.almost-finished {\n  color: white;\n}\n\n.timer-additional-container .time {\n  margin: 0 5px;\n  color: var(--black);\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 120%;\n}\n\n.timer-additional-container .interval {\n  color: var(--white);\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 17px;\n}\n\n\n.timer-additional-container .time.almost-finished {\n  color: var(--white);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
